<template>
  <div class="dropup topic-dropup" v-bind:class="{ show: visible }">
    <button class="btn btn-secondary dropdown-toggle" v-on:click="toggleMenu">
      <slot name="dropup-btn"></slot>
    </button>

    <div class="dropdown-menu" v-on:click="visible = false">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  import clickout from '../mixins/clickout';

  export default {
    name: 'topic-dropup',

    mixins: [
      clickout,
    ],

    data() {
      return {
        visible: false,
      };
    },

    watch: {
      visible(state, old) {
        if (state === old) {
          // Avoid duplicated emits
          return;
        }

        if (state) {
          this.$root.$emit('shown::dropdown', this);
        } else {
          this.$root.$emit('hidden::dropdown', this);
        }
      },
    },

    methods: {
      toggleMenu() {
        this.visible = !this.visible;
      },

      clickOutListener() {
        this.visible = false;
      },

      click() {
        this.toggleMenu();
      },
    },

    created() {
      this.$root.$on('shown::dropdown', (el) => {
        if (el !== this) {
          this.visible = false;
        }
      });
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/TopicDropup.vue